import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import CustomerHelper from "./CustomerHelper";
import RolesHelper from "./RolesHelper";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
const cookies = new Cookies();

class LoginHelper {
    async login(username, password, callback) {
        try {
            if (!username || !password) {
                if (callback) {
                    callback(null);
                }
                return null;
            }

            const encodedCredentials = btoa(
                btoa(username).toString("base64") +
                    ":" +
                    btoa(password).toString("base64")
            ).toString("base64");
            // const encodedCredentials = btoa("hello world").toString("base64");

            Express.callPublic(
                "login",
                { encode: encodedCredentials, loginType: "Customer" },
                (results) => {
                    if (results && results.userId) {
                        if (results && results.authentication) {
                            if (results.authentication.error) {
                                toast.error(
                                    "Unable to authenticate service calls."
                                );
                                return;
                            }
                            cookies.set(
                                "LoginAuthentication",
                                results.authentication
                            );
                            window.localStorage.setItem(
                                "authenticationId",
                                results.authentication
                            );
                        }

                        if (callback) {
                            if (results && results.userId) {
                                window.sessionStorage.setItem(
                                    "userId",
                                    results.userId
                                );
                            } else {
                                window.sessionStorage.removeItem("userId");
                            }

                            if (results && results.roles) {
                                window.sessionStorage.setItem(
                                    "roles",
                                    JSON.stringify(results.roles)
                                );
                            } else {
                                window.sessionStorage.removeItem("roles");
                            }

                            callback(results);
                        }
                    } else {
                        if (callback) {
                            callback(results);
                        }
                        return results;
                    }
                }
            );
        } catch (e) {
            console.log(e);
            callback(null);
        }
    }

    async afterLogin(session) {
        if (session.isLinked) {
            if (RolesHelper.hasAccessLevel(1)) {
                const results = await Express.callAsync("two-way-sync", {
                    userId: session.userId,
                });

                if (results && !results.error) {
                    let message = null;

                    if (results && !results.error) {
                        if (results.email) {
                            message = "Email updated to: " + results.email;
                        }
                        if (results.cell) {
                            message = "Cellphone updated to: " + results.cell;
                        }
                    }

                    if (message) {
                        window.localStorage.setItem("globalMessage", message);
                    }
                }
            }
        }

        window.sessionStorage.setItem("isLinked", session.isLinked);
        window.sessionStorage.setItem("sessionId", session.sessionId);
        setTimeout(() => {
            session.isLinked
                ? (window.location.pathname = "/dashboard")
                : (window.location.pathname = "/link");
        }, 1000);
    }

    logout() {
        Express.call("remove-session", {
            sessionId: window.sessionStorage.getItem("sessionId"),
        });
        window.sessionStorage.clear();
        window.location.href = "/";
    }

    async createUser(userInput, callback) {
        const userInputSchema = (({
            userId,
            firstName,
            lastName,
            email,
            securityQuestions,
            cellPhone,
            password,
            communicationMethods,
            guestInvite,
        }) => ({
            userId,
            firstName,
            lastName,
            email,
            securityQuestions,
            cellPhone,
            password,
            communicationMethods,
            guestInvite,
        }))(userInput);

        userInputSchema.encodedPass = Buffer.from(
            userInputSchema.password
        ).toString("base64");

        delete userInputSchema.password;

        if (userInputSchema.guestInvite) {
            Express.call("remove-guest-invite", {
                invitationId: userInputSchema.guestInvite._id,
            });
        }

        const results = await Express.callAsyncPublic(
            "createNewUser",
            userInputSchema
        );

        if (callback) {
            callback(results);
        }

        return results;
    }

    async updatePassword({ sessionId, userId, password }, callback) {
        try {
            if ((!sessionId && !userId) || !password) {
                return null;
            }

            const encodedPassword = Buffer.from(password).toString("base64");

            const results = await Express.call("update-password", {
                sessionId,
                userId,
                encodedPassword,
            });

            if (callback) {
                callback(results);
            }
            return results;
        } catch (e) {
            console.log(e);
            return null;
        }
    }

    async resetPassword({ userId, password, token }, callback) {
        try {
            if (!userId || !password || !token) {
                if (callback) {
                    callback(null);
                }
                return null;
            }

            const encodedPassword = Buffer.from(password).toString("base64");

            const results = await Express.callPublic("reset-password", {
                token,
                userId,
                encodedPassword,
            });

            if (callback) {
                callback(results);
            }
            return results;
        } catch (e) {
            console.log(e);
            if (callback) {
                callback(null);
            }
            return null;
        }
    }

    agentLogin(username, password, callback) {
        if (!username || !password) {
            if (callback) {
                callback(null);
            }
            return null;
        }
        const encodedCredentials = Buffer.from(
            Buffer.from(username).toString("base64") +
                ":" +
                Buffer.from(password).toString("base64")
        ).toString("base64");

        Express.callPublic(
            "agent-login",
            { encode: encodedCredentials },
            (results) => {
                if (callback) {
                    if (results && results.userId) {
                        window.sessionStorage.setItem(
                            "agentUserId",
                            results.userId
                        );
                    } else {
                        window.sessionStorage.removeItem("agentUserId");
                    }

                    if (results && results.roles) {
                        window.sessionStorage.setItem(
                            "roles",
                            JSON.stringify(results.roles)
                        );
                    } else {
                        window.sessionStorage.removeItem("roles");
                    }

                    if (results && results.authentication) {
                        cookies.set(
                            "LoginAuthentication",
                            results.authentication
                        );
                        window.localStorage.setItem(
                            "authenticationId",
                            results.authentication
                        );
                    }

                    callback(results);
                }
                return results;
            }
        );
    }

    agentLogout() {
        try {
            Express.call("remove-session", {
                sessionId: window.sessionStorage.getItem("sessionId"),
            });
            cookies.remove("LoginAuthentication", {
                path: "/",
            });
            window.sessionStorage.clear();
            //window.location.href = "/agent";
        } catch (e) {
            console.log(e);
        }
    }

    adLogin({ token }, callback) {
        try {
            if (!token) {
                if (callback) {
                    callback({ error: "Invalid parameters." });
                }
                return { error: "Invalid parameters." };
            }

            Express.callPublic(
                "fetch-AD-login-token",
                {
                    tokenId: token,
                },
                (results) => {
                    if (!results || results.status !== 200) {
                        const error = {
                            error: "Unable to to login via Active Directory.",
                        };
                        if (callback) {
                            callback(error);
                        }
                        return error;
                    }

                    if (results && results.userId) {
                        window.sessionStorage.setItem(
                            "agentUserId",
                            results.userId
                        );
                    } else {
                        window.sessionStorage.removeItem("agentUserId");
                    }

                    if (results && results.roles) {
                        window.sessionStorage.setItem(
                            "roles",
                            JSON.stringify(results.roles)
                        );
                    } else {
                        window.sessionStorage.removeItem("roles");
                    }

                    if (results && results.authentication) {
                        cookies.set(
                            "LoginAuthentication",
                            results.authentication
                        );
                        window.localStorage.setItem(
                            "authenticationId",
                            results.authentication
                        );
                    }

                    if (callback) {
                        callback({
                            success: true,
                            status: 200,
                            sessionId: results.sessionId,
                        });
                    }
                    return {
                        success: true,
                        status: 200,
                        sessionId: results.sessionId,
                    };
                }
            );
        } catch (e) {
            console.log(e);
            if (callback) {
                callback({ error: e.message });
            }
            return { error: e.message };
        }
    }

    adminLogin(username, password, callback) {
        if (!username || !password) {
            if (callback) {
                callback(null);
            }
            return null;
        }
        const encodedCredentials = Buffer.from(
            Buffer.from(username).toString("base64") +
                ":" +
                Buffer.from(password).toString("base64")
        ).toString("base64");

        Express.callPublic(
            "admin-login",
            { encode: encodedCredentials },
            (results) => {
                if (callback) {
                    if (results && results.userId) {
                        window.sessionStorage.setItem(
                            "adminUserId",
                            results.userId
                        );
                    } else {
                        window.sessionStorage.removeItem("adminUserId");
                    }

                    if (results && results.roles) {
                        window.sessionStorage.setItem(
                            "roles",
                            JSON.stringify(results.roles)
                        );
                    } else {
                        window.sessionStorage.removeItem("roles");
                    }

                    if (results && results.authentication) {
                        cookies.set(
                            "LoginAuthentication",
                            results.authentication
                        );
                        window.localStorage.setItem(
                            "authenticationId",
                            results.authentication
                        );
                    }

                    callback(results);
                }
                return results;
            }
        );
    }

    adminLogout() {
        Express.call("remove-session", {
            sessionId: window.sessionStorage.getItem("sessionId"),
        });
        window.sessionStorage.clear();
        window.location.href = "/admin";
    }
}

export default new LoginHelper();
